<!--
 * @Author: your name
 * @Date: 2021-03-11 15:58:47
 * @LastEditTime: 2021-08-09 15:53:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\Home.vue
-->
<template>
  <div class="mookHome">
    <!-- :style="{ minHeight: height + 'px' }" -->
    <div class="banner" v-if="banner && banner.length > 0">
      <Carousel :starItemList="banner"></Carousel>
    </div>
    <!-- 畅销榜单 -->
    <div class="best_seller" v-if="starItem">
      <div class="title">
        <p class="txt">{{ starItem.title }}</p>
        <p class="vice_txt">{{ starItem.description }}</p>
      </div>
      <div class="best_seller_list">
        <BestCarousel :starItemList="productData"></BestCarousel>
      </div>
    </div>
    <!-- 产品系列 -->
    <div class="series" v-if="productList && productList.length > 0">
      <SeriesCarousel :productList="productList"></SeriesCarousel>
    </div>

    <!-- 专利/故事 -->
    <div class="patent_story" v-if="articleList && articleList.length > 0">
      <div
        :class="index == 0 ? 'patent' : 'story'"
        v-for="(item, index) in articleList"
        :key="index"
      >
        <img
          class="bg_img"
          v-if="item.imageThumbUrl"
          :src="item.imageThumbUrl"
          @click="exploreMore(index)"
        />
        <!-- <div class="title">{{ item.title }}</div>
        <div class="more_btn" @click="exploreMore(index)">
          {{ lange == "Ch" ? "探索更多" : "もっと探して" }}
        </div> -->
      </div>
    </div>

    <!-- 视频 -->
    <div
      class="vider_player flex_layout"
      v-if="
        video && video.length > 0 && this.playerOptions.sources[0].src != ''
      "
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>

    <Footer :lang="lange"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Carousel from "@/components/Carousel";
import BestCarousel from "@/components/BestCarousel";
import SeriesCarousel from "@/components/SeriesCarousel";
import {
  getBanner,
  categoryList,
  getArticleList,
  carouselByTitle,
  getClassifyList,
} from "@/api/api";

export default {
  name: "Home",
  components: {
    Footer,
    Carousel,
    BestCarousel,
    SeriesCarousel,
  },
  // 定义属性
  data() {
    return {
      height: 0,
      bannerHeight: 0,
      banner: [],
      productData: [],
      isPhone: document.body.clientWidth < 920,
      productList: [],
      starItem: {},
      articleList: [],
      video: null,
      // 视频播放
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: false, //全屏按钮
        },
      },
    };
  },
  created() {
    let pageEnum = "";
    if (this.isPhone) pageEnum = this.lange == "Ch" ? 21 : 22;
    else pageEnum = this.lange == "Ch" ? 1 : 10;
    // 获取banner图
    this.getBannerImg(pageEnum);
    // 单品banner图
    // this.getRankingBanner(pageEnum);
    this.imgLoad();
  },
  // 方法集合
  methods: {
    // 获取轮播图
    async getBannerImg(Enum) {
      const bannerData = await getBanner({ pageEnum: Enum });
      if (bannerData.data.code == -1) return;
      this.banner = bannerData.data.data;
    },
    async getRankingBanner(Enum) {
      const bannerData = await getBanner({ pageEnum: Enum });
      if (bannerData.data.code == -1) return;
      this.banner = bannerData.data.data;
    },
    // 产品系列菜单栏
    getProductList() {
      categoryList({ lang: this.lange == "JPN" ? "ja_JP" : "" }).then((res) => {
        if (res.data.code == 0) {
          // 产品系列
          this.productList = res.data.data[0] && res.data.data[0].childrens;
          // 畅销榜单
          this.starItem = res.data.data[3];
          if (this.starItem) this.getClassifyList(this.starItem.id);
        }
      });
    },
    // 根据分类获取商品
    getClassifyList(id, min = 1, max = 6) {
      // 通过产品类别Id获取对应的产品列表
      let params = {
        productCategoryId: id,
        pageIndex: min,
        pageSize: max,
      };
      getClassifyList(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.productData = res.data.data.data;
          }
        })
        .catch((err) => {
          this.poster = [];
          this.productData = "";
        });
    },
    // 获取专利
    getArticleList(min = 1, max = 6) {
      let params = {
        articleTypeId: this.lange == "Ch" ? 47 : 49,
        pageIndex: min,
        pageSize: max,
      };
      getArticleList(params).then((res) => {
        this.articleList.push(res.data.data.data[0]);
        params.articleTypeId = this.lange == "Ch" ? 42 : 45;
        getArticleList(params).then((res) => {
          if (res.data.data.data.length > 0)
            this.articleList.push(res.data.data.data[0]);
        });
      });
    },
    // 首页视频
    getCarouselByTitle(type) {
      let title = this.lange == "Ch" ? "首页(视频)" : "最初のページ(视频)";
      let params = {
        title: title || "",
      };
      carouselByTitle(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.video = res.data.data;
            if (type) {
              this.porductPoster = this.video;
            } else {
              if (this.video.length > 0)
                this.playerOptions.sources[0].src = this.video[0]
                  ? this.video[0].imageUrl
                  : "";
              // setTimeout(() => {
              //   this.playerOptions.autoplay = true;
              // }, 1000);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 探索更多
    exploreMore(index) {
      // 专利
      if (index == 0) {
        this.$router.push({
          name: "AOG",
          query: {
            id: this.articleList[index].id,
            detail: JSON.stringify(this.articleList[index]),
            index: `2-${index}`,
          },
        });
      } else {
        this.$router.push({
          name: "Introduce",
          query: {
            id: this.articleList[index].id,
            detail: JSON.stringify(this.articleList[index]),
          },
        });
      }
    },
    imgLoad() {
      this.$nextTick(() => {
        if (this.$refs.bannerHeight) {
          let height = [];
          this.$refs.bannerHeight.forEach((v) => {
            height.push(v.height);
          });
          let max = Math.max(...height);
          this.bannerHeight = max ? max - 1 : 0;
        }
      });
    },
  },
  mounted() {
    let height = this.isPhone ? 233 : 509;
    this.height = window.screen.availHeight - height;
    this.getProductList();
    this.getArticleList();
    this.getCarouselByTitle();
  },
};
</script>

<style lang='less' scoped>
.mookHome {
  .banner {
    margin-bottom: 60px;
    &_img {
      width: 100%;
      display: block;
    }
  }
  .programme {
    padding-top: 60px;
    background: #f5f5f5;
  }
  .pro_title {
    width: 100%;
    height: 92px;
    position: relative;
    .tit {
      height: 52px;
      line-height: 52px;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #212121;
      display: inline-block;
      border-bottom: 1px solid #212121;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .small-tit {
      text-align: center;
      margin: 0;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #212121;
      position: absolute;
      left: 50%;
      bottom: 5px;
      transform: translateX(-50%);
    }
  }

  .best_seller {
    margin: 60px 0;
    .title {
      padding: 20px 0 30px;
      text-align: center;
      p {
        padding: 0;
        display: inline-block;
      }
      .txt {
        font-size: 30px;
        font-weight: bold;
        color: #212121;
        padding-bottom:6px ;
        border-bottom: 2px solid #876d4b;
         font-family: "SOURCEHANSANSCN";
      }
      .vice_txt {
        padding: 10px 0 5px;
        font-size: 18px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .series {
    margin: 80px 0;
  }
  .patent_story {
    display: flex;
    justify-content: space-between;
    max-width: 1440px;
    min-width: 1240px;
    height: 500px;
    margin: 80px auto;
    .story,
    .patent {
      width: 710px;
      position: relative;

      .bg_img {
        width: 680px;
        height: 500px;
        position: absolute;
        cursor: pointer;
      }
      .title {
        position: absolute;
        width: 51px;
        padding-bottom: 8px;
        border-bottom: 2px solid #876d4b;
        font-size: 24px;
        font-weight: bold;
        color: #212121;
        line-height: 31px;
        top: 165px;
      }
      .more_btn {
        width: 200px;
        height: 64px;
        position: absolute;
        bottom: 166px;
        border: 1px solid #876d4b;
        font-size: 18px;
        font-weight: 400;
        color: #876d4b;
        text-align: center;
        line-height: 64px;
        cursor: pointer;
      }
    }
    .story {
      .bg_img {
        left: 0;
      }
      .title {
        right: 150px;
      }
      .more_btn {
        right: 0;
      }
    }
    .patent {
      .title {
        left: 150px;
      }
      .bg_img {
        right: 0;
      }
      .more_btn {
        left: 0;
      }
    }
  }
  .vider_player {
    max-width: 1440px;
    min-width: 1240px;
    margin: 80px auto;
    .play_button {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      border: 1px solid #fff;
    }
    .button_bg {
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.1;
      border-radius: 50%;
    }
    .play_icon {
      width: 43px;
    }
  }
}
</style>
